import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { Mail } from 'lucide-react';
import { adminQueries } from '@blimo/api-client';
import { useApi } from '@blimo/api-client/react';
import { formatDateTime } from '@blimo/shared';
import { Badge, EmptyState, ErrorState, PageHeader, Skeleton, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@blimo/ui';

/** Kommunikation › Vorlagen (F-506). */
export function MailTemplatesPage() {
  const api = useApi();
  const { data, error, isPending, refetch } = useQuery(adminQueries.mailTemplates(api));
  return (
    <>
      <PageHeader title="Vorlagen" description="Betreff und Text der automatischen E-Mails. Ohne eigenen Text gilt der Standardtext." />
      {error ? (
        <ErrorState error={error} onRetry={() => refetch()} />
      ) : isPending ? (
        <Skeleton className="h-64 w-full" />
      ) : data.length === 0 ? (
        <EmptyState icon={Mail} title="Keine Vorlagen" />
      ) : (
        <Table aria-label="Mail-Vorlagen" containerClassName="rounded-md border">
          <TableHeader>
            <TableRow>
              <TableHead>Vorlage</TableHead>
              <TableHead>Schlüssel</TableHead>
              <TableHead>Text</TableHead>
              <TableHead>Geändert</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((t) => (
              <TableRow key={t.key}>
                <TableCell>
                  <Link to="/kommunikation/vorlagen/$templateKey" params={{ templateKey: t.key }} className="font-medium text-primary hover:underline">
                    {t.label}
                  </Link>
                </TableCell>
                <TableCell className="font-mono text-xs">{t.key}</TableCell>
                <TableCell>{t.customized ? <Badge variant="info">Angepasst</Badge> : <Badge variant="neutral">Standard</Badge>}</TableCell>
                <TableCell className="numeric">{t.updated_at ? formatDateTime(t.updated_at) : '–'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
}
